import { inject_rb_form } from '../form';

const main_view = {
    template: require('./view.html'),
};
const state_config = inject_rb_form({
    url: '/retention_churn',
    reloadOnSearch: false,
    data: {
        title: 'Retention Churn',
    },
    views: {
        '': main_view,
    },
});
export default state_config;
